export default "__VITE_ASSET__5V3S4rWa__"